import React from 'react';
import { Badge } from '../../../components/ui/badge';
import { Grupo } from '../../../types/grupos';

interface GrupoHeaderProps {
  grupo: Grupo;
}

export const GrupoHeader: React.FC<GrupoHeaderProps> = ({ grupo }) => {
  return (
    <div className="flex items-center gap-4 border-b border-border pb-4">
      <div className="flex-1">
        <div className="flex items-center gap-3">
          <img
            src={grupo.img}
            alt={grupo.grupo}
            className="w-12 h-12 rounded-lg object-cover"
            onError={(e) => {
              e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iOCIgZmlsbD0iIzNiODJmNiIvPgo8cGF0aCBkPSJNMjQgMTJjNi42MjcgMCAxMiA1LjM3MyAxMiAxMnMtNS4zNzMgMTItMTIgMTItMTItNS4zNzMtMTItMTIgNS4zNzMtMTIgMTItMTJ6bTAgNGMtNC40MTggMC04IDMuNTgyLTggOHMzLjU4MiA4IDggOCA4LTMuNTgyIDgtOC0zLjU4Mi04LTgtOHoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=';
            }}
          />
          <div>
            <h1 className="text-2xl font-bold text-foreground">{grupo.grupo}</h1>
            <p className="text-muted-foreground">{grupo.descricao}</p>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-2">
          <Badge className={
            grupo.status === "A"
              ? "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800"
              : "bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700"
          }>
            {grupo.status === "A" ? "Ativo" : "Inativo"}
          </Badge>
          {grupo.tipo && (
            <Badge className="bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800">
              {grupo.tipo.nome}
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
};
